<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'ExpertRessourcesOrganiserSaFormation'
});
</script>
<template>
  <ka-container
    code="expert-ressource-3-organiser-sa-formatio"
    :data="page.$info.expertRessource3OrganiserSaFormatio">
    <!-- Ressources - Experts -->
    <ka-container code="ressources-experts">
      <!-- Titrage -->
      <ka-container code="titrage">
        <ka-text
          code="toutes-les-ressources"
          :options="{
            href: { name: `hub-expert-Ressources` },
            click: page.toutesLesRessourcesClick
          }"
          :xs="{ hidden: null }">
          <span v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.titrage.toutesLesRessources.value', `< Toutes les ressources`)" />
        </ka-text>
        <ka-text code="comment-bien-organiser">
          <h1 v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.titrage.commentBienOrganiser.value', `<strong>Comment bien organiser sa formation ? </strong>`)" />
        </ka-text>
        <!-- Container -->
        <ka-container code="container" />
      </ka-container>
      <!-- Gauche -->
      <ka-container code="gauche">
        <ka-text code="titre">
          <h2 v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.gauche.titre.value', `Repartir de l’existant `)" />
        </ka-text>
        <ka-text code="pour-organiser-la-formation">
          <span v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.gauche.pourOrganiserLaFormation.value', `Pour organiser la formation sur plusieurs séances, vous ne partez pas de 0. <strong>Vous avez déjà :</strong>`)" />
        </ka-text>
        <!-- Container -->
        <ka-container code="container-1">
          <!-- Container -->
          <ka-container code="container-2">
            <ka-text code="rencontre-les">
              <span v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.gauche.container1.container2.RencontreLes.value', `<strong>✅   Rencontré les apprenants lors d’un entretien découverte </strong>`)" />
            </ka-text>
            <ka-text code="cet-entretien-vous">
              <span v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.gauche.container1.container2.cetEntretienVous.value', `<span style='background-color:transparent;color:#000000;'>Cet entretien vous a permis de cerner <strong>les enjeux et les objectifs de l’entreprise </strong>auprès de laquelle vous allez intervenir. L'objectif d’une <strong>formation</strong> étant de permettre aux apprenants de monter en compétences, pour atteindre leur(s) objectif(s) il va falloir <strong>séquencer l’apprentissage</strong>, réitérer certaines manipulations et répéter les notions théoriques à avoir.</span>`)" />
            </ka-text>
          </ka-container>
          <!-- Container -->
          <ka-container code="container-3">
            <ka-text code="etabli-un-programme">
              <span v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.gauche.container1.container3.EtabliUnProgramme.value', `<strong>✅   Établi un programme de formation</strong>`)" />
            </ka-text>
            <ka-text code="grace-au-programme">
              <span v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.gauche.container1.container3.graceAuProgramme.value', `<span style='background-color:transparent;color:#000000;'>Grâce au <strong>programme de formation </strong>vous avez une vision des différentes étapes par lesquelles les apprenants doivent passer pour <strong>atteindre leur(s) objectif(s) </strong>et ainsi <strong>monter en compétences</strong>.</span>`)" />
            </ka-text>
          </ka-container>
        </ka-container>
        <ka-text code="dapres-ces-deux-elements">
          <span v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.gauche.dapresCesDeuxElements.value', `D’après ces deux éléments et les <strong>objectifs pédagogiques </strong>(présents dans le programme de formation) vous pouvez<strong> lister toutes les connaissances et références nécessaires</strong> pour franchir chaque étape. Vous pouvez regrouper toutes ces connaissances sur le <a href='/hub-expert/ressources/construire-support-de-formation'><span style='color:#D93174FF;'>SUPPORT DE FORMATION</span></a>. `)" />
        </ka-text>
        <ka-text code="k-4-etapes">
          <h2 v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.gauche.k4Etapes.value', `Mise en pratique d’un plan d’actions`)" />
        </ka-text>
        <ka-text code="pensez-la-formation">
          <span v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.gauche.pensezLaFormation.value', `Pensez la formation comme la mise en pratique d’un plan d’actions. En tentant d'<strong>atteindre un but</strong>, l’entreprise passe par toutes les étapes nécessaires pour obtenir des résultats. À chaque étape, l’<strong>expert apporte ses savoirs et savoir-faire</strong> pour que l’entreprise avance plus vite et dans la bonne direction. Véritable moteur du projet, vous guidez les actions d’un cas pratique, celui de l’entreprise. Cette montée en compétences, inscrite dans l'environnement des apprenants (outils, contraintes, budget…) rend la <strong>formation </strong>vraiment<strong> utile</strong> et combine <strong>temps d’apprentissage</strong> et <strong>mise en pratique</strong>. `)" />
        </ka-text>
        <ka-text code="entre-chaque-session">
          <span v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.gauche.entreChaqueSession.value', `Entre chaque session, <strong>les apprenants doivent poursuivre le projet</strong> pour arriver à la session d’après avec leurs questions, les problèmes qu’ils ont rencontré ou les résultats obtenus. Pour eux, la formation ne dure pas seulement pendant les séances mais bien de la première à la dernière session.`)" />
        </ka-text>
        <ka-text code="en-fin-de-session">
          <span v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.gauche.enFinDeSession.value', `En fin de session, n’hésitez pas à lister les actions à mettre en pratique pour la prochaine séance ! <br> <br><span style='background-color:transparent;color:#D93174FF;'>> Comment animer la formation ?</span><br><span style='background-color:transparent;color:#D93174FF;'>> La posture de l'expert Matchers</span>`)" />
        </ka-text>
        <ka-text code="k-6-conseils">
          <h2 v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.gauche.k6Conseils.value', `L’adaptabilité, facteur clé de réussite d’une formation Matchers`)" />
        </ka-text>
        <ka-text code="nos-formations-ont">
          <span v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.gauche.nosFormationsOnt.value', `<strong>Nos formations</strong> ont pour objectif d’être vraiment utiles. Pour cela, une grosse partie de l’apprentissage passe par la <strong>mise en pratique quasi immédiate</strong> des apprenants. <strong>La formation </strong>peut donc évoluer en cours de route. Peut-être qu’une notion peut être acquise plus vite que ce qui était prévu ou au contraire, une problématique peut émerger d’une session à l’autre.<br> <br>Dans ces situations, l’expert doit s’adapter pour toujours accompagner l’entreprise à atteindre les objectifs énoncés dans le programme de formation.`)" />
        </ka-text>
        <ka-image
          code="image-3"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Image 3`
          }"
          value="https://ucarecdn.com/c795f1fb-ebcd-4ba0-9f5f-e0726e10eaec/" />
        <ka-text code="si-une-problematique">
          <span v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.gauche.SiUneProblematique.value', `⚠️   Si une problématique émerge et sort de votre champ de compétences ou est très éloignée du programme de formation, il est impératif de prendre contact avec Matchers pour échanger au sujet de la suite de la formation. `)" />
        </ka-text>
        <ka-text code="k-10-conseils">
          <h2 v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.gauche.k10Conseils.value', `<span style='background-color:transparent;color:#1100A2FF;'><strong>Nos 8 conseils pour préparer sa première session de formation</strong></span>`)" />
        </ka-text>
        <ka-text code="vous-allez-realiser">
          <span v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.gauche.vousAllezRealiser.value', `Vous allez réaliser <strong>votre première formation Matchers</strong>. Cela implique un minimum de préparation et peut être d’appréhension :<br> <br>Est-ce que j’aurai suffisamment de choses à transmettre ? Est-ce que je vais respecter le temps prévu ? Et si je ne sais pas répondre à toutes les questions ?<br> <br>C'est normal !`)" />
        </ka-text>
        <!-- conseils déroulent -->
        <ka-container code="conseils-deroulent">
          <DropDownRessource
            instance-class="drop-down-ressource--p97"
            title="1.   Faire un tour de table"
            :content-text="page.$constants.dropDownRessourceContentText" />
          <DropDownRessource
            instance-class="element-1--p97"
            title="2.   Reprendre le programme de formation "
            content-text="Une fois de plus, le <strong>programme de formation</strong> agit comme fil conducteur et permet de mettre tout le monde d’accord. Vous pouvez rappeler les <strong>objectifs pédagogiques de la formation </strong>pour valider avec les apprenants la direction que doit prendre l'accompagnement. <br> <br>Effectivement, il se peut que plusieurs participants à la formation n'aient jamais participé aux échanges précédents et désirent avoir une vue d’ensemble. <br> <br>👉  Où va t-on et quelles étapes devons-nous franchir pour atteindre nos objectifs ?<br> " />
          <DropDownRessource
            instance-class="element-2--p97"
            title="3.   Présenter votre manière de travailler"
            :content-text="page.$constants.element2ContentText" />
          <DropDownRessource
            instance-class="element-3--p97"
            title="4.   Présenter le sommaire que vous avez préparer"
            :content-text="page.$constants.element3ContentText" />
          <DropDownRessource
            instance-class="element-4--p97"
            title="5.   Utiliser la position basse pour comprendre l’organisation"
            :content-text="page.$constants.element4ContentText" />
          <DropDownRessource
            instance-class="element-5--p97"
            title="6.   Présenter vos premières slides"
            content-text="Vous prenez maintenant la main avec une introduction théorique. Quelques principes de bases et concepts incontournables de votre domaine d’expertise ou bien même un peu d’histoire. Pour cette partie, vous adoptez la position haute, <strong>celle de l’expert qui transmet son savoir</strong>. <br> " />
          <DropDownRessource
            instance-class="element-6--p97"
            title="7.   Passer à la pratique"
            :content-text="page.$constants.element6ContentText" />
          <DropDownRessource
            instance-class="element-7--p97"
            title="8.   Rester à l’écoute des retours"
            content-text="Au cours de chaque session, les apprenants seront amenés à vous faire des retours, à vous poser des questions. Ces questions soulèvent sans doute des lacunes et des besoins pour les prochaines séances. <br> " />
        </ka-container>
        <ka-text code="text-1">
          <h2 v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.gauche.text1.value', `Anticiper la session suivante`)" />
        </ka-text>
        <ka-text code="un-seance-doit-se-cloturer">
          <span v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.gauche.unSeanceDoitSeCloturer.value', `Un séance doit se clôturer par la préparation de la prochaine séance. `)" />
        </ka-text>
        <!-- Container exemples -->
        <ka-container code="container-exemples">
          <!-- Container -->
          <ka-container code="container-4">
            <!-- Container -->
            <ka-container code="container-5">
              <ka-text code="les-apprenants-et">
                <h1 v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.gauche.containerExemples.container4.container5.lesApprenantsEt.value', `<strong>LES APPRENANTS ET L’EXPERT</strong>`)" />
              </ka-text>
            </ka-container>
            <ka-text code="le-resume-de-ce">
              <span v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.gauche.containerExemples.container4.leResumeDeCe.value', `<ul><li><strong>Le résumé </strong>de ce qui a été abordé au cours de la session. Vous pouvez d’ailleurs l’inscrire sur une slide du support de formation si vous le souhaitez.</li></ul><p> </p><ul><li><strong>Des “devoirs”</strong>, c'est-à-dire, les sujets sur lesquels l’entreprise doit avancer d’ici la prochaine séance.</li></ul><p> </p><ul><li>Rappeler l’importance de signer les<strong> feuilles d’émargement</strong>.</li></ul><p> </p><ul><li>Réserver la prochaine séance de formation.</li></ul><p> </p>`)" />
            </ka-text>
          </ka-container>
          <!-- Container -->
          <ka-container code="container-6">
            <!-- Container -->
            <ka-container code="container-7">
              <ka-text code="seulement-lexpert">
                <h1 v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.gauche.containerExemples.container6.container7.seulementLexpert.value', `<strong>SEULEMENT L’EXPERT</strong>`)" />
              </ka-text>
            </ka-container>
            <ka-text code="noter-les-notions">
              <span v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.gauche.containerExemples.container6.noterLesNotions.value', `<ul><li>Noter les notions à aborder pour la prochaine séance.</li></ul><p> </p><ul><li>Anticiper sous forme de prise de notes les éléments à intégrer dans les <span style='color:#D93174FF;'>évaluations de fin de formation</span>.</li></ul><p> </p>`)" />
            </ka-text>
          </ka-container>
        </ka-container>
        <ka-text code="text-2">
          <h2 v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.gauche.text2.value', `Une session de formation type`)" />
        </ka-text>
        <ka-text code="definir-un-objectif">
          <span v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.gauche.definirUnObjectif.value', `Définir un objectif à chaque session : Qu’est ce que les apprenants doivent-ils avoir appris, fait ou fourni depuis la dernière session ?`)" />
        </ka-text>
        <!-- Container -->
        <ka-container code="container-8">
          <ka-text code="session-de-2-h">
            <span v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.gauche.container8.sessionDe2H.value', `<p><strong>Session de 2h : </strong> </p><p> </p><ul><li>15min - Exposition des apprenants sur ce qu’ils ont fait</li><li>20min - Retour de l’expert</li><li>15min - Apports théoriques</li><li>30min - L’expert prend la main et montre la mise en pratique</li><li>30min - Les apprenants prennent la main</li><li>10min - Point de fin de séance : ToDo pour la prochaine séance + Compléter le support de formation avec ce qui a été vu + Compléter le rapport des évaluations de mise en pratique (10min)</li></ul>`)" />
          </ka-text>
        </ka-container>
      </ka-container>
      <!-- Droite -->
      <ka-container code="droite">
        <!-- Container -->
        <ka-container
          code="container-9"
          :xs="{ hidden: null }">
          <ka-text code="text-3">
            <span v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.droite.container9.text3.value', `<strong>Sommaire :</strong>`)" />
          </ka-text>
          <ka-text
            code="text-4"
            :options="{
              href: { hash: `#text-3--p97` },
              ariaLabel: `text`,
              click: page.text4Click
            }">
            <span v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.droite.container9.text4.value', `<ul><li>Repartir de l'existant</li></ul>`)" />
          </ka-text>
          <ka-text
            code="text-5"
            :options="{
              href: { hash: `#text-3--p97` },
              ariaLabel: `text`,
              click: page.text5Click
            }">
            <span v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.droite.container9.text5.value', `<ul><li>Mise en pratique d'un plan d'actions</li></ul>`)" />
          </ka-text>
          <ka-text
            code="text-6"
            :options="{
              href: { hash: `#text-3--p97` },
              ariaLabel: `text`,
              click: page.text6Click
            }">
            <span v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.droite.container9.text6.value', `<ul><li>L’adaptabilité, facteur clé de réussite d’une formation Matchers</li></ul>`)" />
          </ka-text>
          <ka-text
            code="text-7"
            :options="{
              href: { hash: `#text-3--p97` },
              ariaLabel: `text`,
              click: page.text7Click
            }">
            <span v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.droite.container9.text7.value', `<ul><li>Nos 8 conseils pour préparer sa première session de formation</li></ul>`)" />
          </ka-text>
          <ka-text
            code="text-8"
            :options="{
              href: { hash: `#text-3--p97` },
              ariaLabel: `text`,
              click: page.text8Click
            }">
            <span v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.droite.container9.text8.value', `<ul><li>Anticiper la session suivante</li></ul>`)" />
          </ka-text>
          <ka-text
            code="text-9"
            :options="{
              href: { hash: `#text-3--p97` },
              ariaLabel: `text`,
              click: page.text9Click
            }">
            <span v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.droite.container9.text9.value', `<ul><li>Une session de formation type</li></ul>`)" />
          </ka-text>
        </ka-container>
        <!-- Container 2 -->
        <ka-container code="container-10">
          <ka-text code="text-10">
            <span v-html="t('expertRessource3OrganiserSaFormatio.ressourcesExperts.droite.container10.text10.value', `Autres ressources disponibles :`)" />
          </ka-text>
          <BlocPreviewRessourceSansDescription
            instance-class="preview-ressource-short--p97"
            :options="{
              href: { name: `hub-expert-Ressources-construire-support-de-formation` },
              click: page.previewRessourceShortClick
            }"
            title="<strong>Comment créer mon support de formation ?</strong>"
            image="https://ucarecdn.com/a2a44513-0560-4647-bf8d-08185038c949/" />
          <BlocPreviewRessourceSansDescription
            instance-class="element-8--p97"
            :options="{
              href: { name: `Expert-Ressources-animer-la-formation` },
              click: page.element8Click
            }"
            title="<strong>Animer la formation</strong>"
            image="https://images.unsplash.com/photo-1612831455359-970e23a1e4e9?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyOTM3MTZ8MHwxfHNlYXJjaHw5fHxwciVDMyVBOXNlbnRhdGlvbnxlbnwwfHx8fDE2OTIyNjA3OTJ8MA&ixlib=rb-4.0.3&q=80&w=1080" />
          <BlocPreviewRessourceSansDescription
            instance-class="element-9--p97"
            :options="{
              href: { name: `Expert-Ressources-Evaluations` },
              click: page.element9Click
            }"
            title="<strong>Évaluer les apprentissages</strong>"
            image="https://images.unsplash.com/photo-1518349619113-03114f06ac3a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyOTM3MTZ8MHwxfHNlYXJjaHwzMHx8dGVzdHxlbnwwfHx8fDE2OTIyODY5NjR8MA&ixlib=rb-4.0.3&q=80&w=1080" />
        </ka-container>
      </ka-container>
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { expertRessourcesOrganiserSaFormation } from './store'
import BlocPreviewRessourceSansDescription from '~/components/BlocPreviewRessourceSansDescription/index.vue'
import DropDownRessource from '~/components/DropDownRessource/index.vue'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p97')
const appData = appDataStore()
const page = expertRessourcesOrganiserSaFormation()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
